export default __webpack_public_path__ + "static/media/resume.c0eb1206.pdf";